var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4534 11.3064L12.3668 6.43309C11.6601 4.77976 10.3601 4.71309 9.48678 6.28643L8.22678 8.55976C7.58678 9.71309 6.39345 9.81309 5.56678 8.77976L5.42011 8.59309C4.56011 7.51309 3.34678 7.64643 2.72678 8.87976L1.58011 11.1798C0.773447 12.7798 1.94011 14.6664 3.72678 14.6664H12.2334C13.9668 14.6664 15.1334 12.8998 14.4534 11.3064Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64648 5.3335C5.75105 5.3335 6.64648 4.43807 6.64648 3.3335C6.64648 2.22893 5.75105 1.3335 4.64648 1.3335C3.54191 1.3335 2.64648 2.22893 2.64648 3.3335C2.64648 4.43807 3.54191 5.3335 4.64648 5.3335Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountGallery);
export default __webpack_public_path__ + "static/media/count-gallery.373c57b03b5c0a0cfe9286d520f5b344.svg";
export { ForwardRef as ReactComponent };